"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureProfileDetails = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _Card = _interopRequireDefault(require("../Card"));
var _MyAccountInput = _interopRequireDefault(require("../MyAccountInput"));
var _MyAccountConsentsStyled = require("../MyAccountConsents/MyAccountConsentsStyled");
var _validators = require("../../util/validators");
var _updateCustomer = _interopRequireDefault(require("../../api/Customer/updateCustomer"));
var _updateCaptureAnswers = _interopRequireDefault(require("../../api/Customer/updateCaptureAnswers"));
var _auth = _interopRequireDefault(require("../../services/auth"));
var _SkeletonWrapper = _interopRequireDefault(require("../SkeletonWrapper"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _ProfileDetailsStyled = require("./ProfileDetailsStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-did-update-set-state */

const InputsData = [{
  id: 'firstName',
  label: 'First Name',
  onBlur: 'areNamesValid',
  type: 'text'
}, {
  id: 'lastName',
  label: 'Last Name',
  onBlur: 'areNamesValid',
  type: 'text'
}, {
  id: 'email',
  label: 'E-mail',
  onBlur: 'areEmailAndPasswordValid',
  type: 'email'
}, {
  id: 'confirmationPassword',
  label: 'Confirmation password',
  onBlur: 'areEmailAndPasswordValid',
  type: 'password'
}, {
  id: 'birthDate',
  label: 'Birth Date',
  onBlur: 'isBirthDateValid',
  type: 'date'
}, {
  id: 'phoneNumber',
  label: 'Phone Number',
  onBlur: 'isPhoneNumberValid',
  type: 'tel'
}, {
  id: 'companyName',
  label: 'Company Name',
  onBlur: 'isCompanyNameValid',
  type: 'text'
}];
class ProfileDetails extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "updateProfile", e => {
      e.preventDefault();
      const {
        updated
      } = this.state;
      const {
        email,
        setCurrentUser,
        updateCaptureOption,
        t
      } = this.props;
      const shouldLogOut = updated.email !== email;
      if (!this.areNamesValid() || !this.areEmailAndPasswordValid() || !this.isBirthDateValid() || !this.isCompanyNameValid() || !this.isPhoneNumberValid()) {
        return;
      }
      this.setState({
        isSubmittingPending: true
      });
      (0, _updateCustomer.default)({
        firstName: updated.firstName,
        lastName: updated.lastName,
        email: updated.email !== email ? updated.email : '',
        confirmationPassword: updated.email !== email ? updated.confirmationPassword : ''
      }).then(response => {
        this.setState({
          isSubmittingPending: false
        });
        if (response.errors.length) {
          const errorMsg = response.errors[0];
          const isEmailError = errorMsg.includes('mail');
          const isPasswordError = errorMsg.includes('confirmationPassword');
          this.setState({
            errors: {
              confirmationPassword: isPasswordError ? t('Incorect password') : '',
              email: isEmailError ? errorMsg : ''
            },
            successMessage: false
          });
        } else {
          setCurrentUser(response.responseData);
          this.setState({
            isSectionDisabled: true,
            successMessage: true
          });
          if (shouldLogOut) {
            _auth.default.logout();
          }
        }
      });
      this.setState({
        isSubmittingPending: true
      });
      (0, _updateCaptureAnswers.default)({
        birthDate: updated.birthDate,
        companyName: updated.companyName,
        phoneNumber: updated.phoneNumber
      }).then(() => {
        updateCaptureOption({
          key: 'birthDate',
          value: updated.birthDate
        });
        updateCaptureOption({
          key: 'companyName',
          value: updated.companyName
        });
        updateCaptureOption({
          key: 'phoneNumber',
          value: updated.phoneNumber
        });
        this.setState({
          isSubmittingPending: false,
          isSectionDisabled: true,
          successMessage: true
        });
      });
    });
    (0, _defineProperty2.default)(this, "isBirthDateValid", () => {
      const {
        updated
      } = this.state;
      const {
        t,
        birthDate: {
          enabled,
          required
        }
      } = this.props;
      const isBirthDateRequired = enabled && required;
      if (isBirthDateRequired && !updated.birthDate) {
        this.setState({
          errors: {
            birthDate: t('Birth date is required')
          }
        });
        return false;
      }
      return true;
    });
    (0, _defineProperty2.default)(this, "areNamesValid", () => {
      var _capture$settings;
      const {
        updated
      } = this.state;
      const {
        t,
        capture
      } = this.props;
      const namesSettings = capture === null || capture === void 0 || (_capture$settings = capture.settings) === null || _capture$settings === void 0 ? void 0 : _capture$settings.find(setting => setting.key === 'firstNameLastName');
      const {
        enabled,
        required
      } = namesSettings;
      const areNamesRequired = enabled && required;
      if (areNamesRequired && !updated.firstName.length) {
        this.setState({
          errors: {
            firstName: t('First name is required')
          }
        });
        return false;
      }
      if (areNamesRequired && !updated.lastName.length) {
        this.setState({
          errors: {
            lastName: t('Last name is required')
          }
        });
        return false;
      }
      if (updated.firstName.length > 50 || updated.lastName.length > 50) {
        this.setState({
          errors: {
            firstName: updated.firstName.length > 50 ? t('First name can have max 50 characters') : '',
            lastName: updated.lastName.length > 50 ? t('Last name can have max 50 characters') : ''
          }
        });
        return false;
      }
      this.setState({
        errors: {
          firstName: '',
          lastName: ''
        }
      });
      return true;
    });
    (0, _defineProperty2.default)(this, "areEmailAndPasswordValid", () => {
      const {
        updated
      } = this.state;
      const {
        email,
        t
      } = this.props;
      if (updated.email === email) {
        this.setState({
          errors: {
            email: ''
          }
        });
        return true;
      }
      const isEmailValid = !(0, _validators.validateEmailField)(updated.email).length;
      const isPasswordValid = !!updated.confirmationPassword;
      if (!isEmailValid || !isPasswordValid) {
        this.setState({
          errors: {
            email: (0, _validators.validateEmailField)(updated.email),
            confirmationPassword: updated.confirmationPassword ? '' : t('Please confirm your password to proceed with changing your email address.')
          }
        });
        return false;
      }
      this.setState({
        errors: {
          email: '',
          confirmationPassword: ''
        }
      });
      return true;
    });
    (0, _defineProperty2.default)(this, "isPhoneNumberValid", () => {
      const {
        updated
      } = this.state;
      const {
        t,
        phoneNumber: {
          enabled,
          required
        }
      } = this.props;
      const isPhoneNumberRequired = enabled && required;
      if (isPhoneNumberRequired && !updated.phoneNumber) {
        this.setState({
          errors: {
            phoneNumber: t('Phone number is required')
          }
        });
        return false;
      }
      const regexp = /^[0-9()+-\s]+$/;
      if (updated.phoneNumber && !regexp.test(updated.phoneNumber)) {
        this.setState({
          errors: {
            phoneNumber: t('This is not a valid phone number')
          }
        });
        return false;
      }
      this.setState({
        errors: {
          phoneNumber: ''
        }
      });
      return true;
    });
    (0, _defineProperty2.default)(this, "isCompanyNameValid", () => {
      const {
        updated
      } = this.state;
      const {
        t,
        companyName: {
          enabled,
          required
        }
      } = this.props;
      const isCompanyNameRequired = enabled && required;
      if (isCompanyNameRequired && !updated.companyName) {
        this.setState({
          errors: {
            companyName: t('Company name is required')
          }
        });
        return false;
      }
      if (updated.companyName && updated.companyName.length > 50) {
        this.setState({
          errors: {
            companyName: updated.companyName.length > 50 ? t('Company name can have max 50 characters') : ''
          }
        });
        return false;
      }
      this.setState({
        errors: {
          companyName: ''
        }
      });
      return true;
    });
    (0, _defineProperty2.default)(this, "handleInputChange", (fieldName, inputValue) => {
      this.setState(prevState => ({
        updated: {
          ...prevState.updated,
          [fieldName]: inputValue
        }
      }));
    });
    this.state = {
      updated: {
        firstName: '',
        lastName: '',
        email: '',
        confirmationPassword: '',
        birthDate: '',
        phoneNumber: '',
        companyName: ''
      },
      errors: {
        firstName: '',
        lastName: '',
        email: '',
        confirmationPassword: '',
        birthDate: '',
        phoneNumber: '',
        companyName: ''
      },
      isSectionDisabled: true,
      isSubmittingPending: false,
      successMessage: false
    };
  }
  componentDidMount() {
    const {
      firstName,
      lastName,
      email,
      birthDate,
      phoneNumber,
      companyName
    } = this.props;
    const {
      updated
    } = this.state;
    this.setState({
      updated: {
        ...updated,
        firstName,
        lastName,
        email,
        birthDate: birthDate ? birthDate.answer : '',
        phoneNumber: phoneNumber ? phoneNumber.answer : '',
        companyName: companyName ? companyName.answer : ''
      }
    });
  }
  componentDidUpdate() {
    const {
      updated,
      isSectionDisabled
    } = this.state;
    const {
      firstName,
      lastName,
      email,
      birthDate,
      phoneNumber,
      companyName
    } = this.props;
    if (isSectionDisabled && (firstName !== updated.firstName || lastName !== updated.lastName || email !== updated.email || birthDate && birthDate.answer !== updated.birthDate || phoneNumber && phoneNumber.answer !== updated.phoneNumber || companyName && companyName.answer !== updated.companyName)) {
      this.setState({
        updated: {
          ...updated,
          firstName,
          lastName,
          email,
          confirmationPassword: '',
          birthDate: birthDate ? birthDate.answer : '',
          phoneNumber: phoneNumber ? phoneNumber.answer : '',
          companyName: companyName ? companyName.answer : ''
        }
      });
    }
  }
  render() {
    var _capture$settings2;
    const {
      firstName,
      lastName,
      capture,
      email,
      isLoading,
      t
    } = this.props;
    const {
      updated,
      isSectionDisabled,
      isSubmittingPending,
      errors,
      successMessage
    } = this.state;
    const areNamesRequired = capture === null || capture === void 0 || (_capture$settings2 = capture.settings) === null || _capture$settings2 === void 0 || (_capture$settings2 = _capture$settings2.find(setting => setting.key === 'firstNameLastName')) === null || _capture$settings2 === void 0 ? void 0 : _capture$settings2.required;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileDetailsStyled.WrapStyled, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Card.default, {
        withBorder: true,
        children: isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [[...Array(3)].map((i, k) =>
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          (0, _jsxRuntime.jsxs)(_react.default.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
              width: 100,
              margin: "0 0 12px 0"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
              height: 40,
              margin: "0 0 28px 0"
            })]
          }, "skeleton-item-".concat(k))), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
            height: 40,
            width: 140,
            margin: "40px 0 0 auto"
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ProfileDetailsStyled.FormStyled, {
          onSubmit: this.updateProfile,
          children: [successMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountConsentsStyled.SuccessMessageStyled, {
            children: t('Your profile details have been changed successfully')
          }), InputsData.map(input => {
            var _this$props$input$id;
            const shouldBeHidden = typeof this.props[input.id] === 'object' && !((_this$props$input$id = this.props[input.id]) !== null && _this$props$input$id !== void 0 && _this$props$input$id.enabled);
            const isRequired = () => {
              var _this$props$input$id2;
              switch (input.id) {
                case 'firstName':
                case 'lastName':
                  return areNamesRequired;
                case 'email':
                  return true;
                default:
                  return (_this$props$input$id2 = this.props[input.id]) === null || _this$props$input$id2 === void 0 ? void 0 : _this$props$input$id2.required;
              }
            };
            return !shouldBeHidden ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountInput.default, {
              id: input.id,
              value: updated[input.id] || '',
              label: t(input.label),
              onChange: e => this.handleInputChange(input.id, e.target.value),
              disabled: isSectionDisabled,
              error: errors[input.id],
              onBlur: this[input.onBlur],
              type: input.type,
              name: input.id,
              hideInput: input.id === 'confirmationPassword' && updated.email === email,
              autoComplete: input.id === 'confirmationPassword' ? 'new-password' : 'off',
              required: isRequired()
            }, input.id) : null;
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountConsentsStyled.ButtonWrapperStyled, {
            children: isSectionDisabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountConsentsStyled.ButtonStyled, {
              onClickFn: () => this.setState({
                isSectionDisabled: false
              }),
              width: "100%",
              children: t('Edit Profile')
            }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountConsentsStyled.ButtonStyled, {
                theme: "simple",
                onClickFn: () => this.setState({
                  isSectionDisabled: true,
                  updated: {
                    firstName,
                    lastName,
                    email,
                    confirmationPassword: ''
                  },
                  errors: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    confirmationPassword: ''
                  }
                }),
                children: t('Cancel')
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountConsentsStyled.ButtonStyled, {
                onClickFn: this.updateProfile,
                disabled: isSubmittingPending,
                type: "submit",
                theme: "confirm",
                children: isSubmittingPending && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
                  buttonLoader: true,
                  color: "#ffffff"
                }) || t('Save')
              })]
            })
          })]
        })
      })
    });
  }
}
exports.PureProfileDetails = ProfileDetails;
ProfileDetails.propTypes = {
  firstName: _propTypes.default.string,
  lastName: _propTypes.default.string,
  email: _propTypes.default.string,
  birthDate: _propTypes.default.objectOf(_propTypes.default.any),
  phoneNumber: _propTypes.default.objectOf(_propTypes.default.any),
  companyName: _propTypes.default.objectOf(_propTypes.default.any),
  isLoading: _propTypes.default.bool,
  setCurrentUser: _propTypes.default.func,
  updateCaptureOption: _propTypes.default.func,
  capture: _propTypes.default.objectOf(_propTypes.default.any),
  t: _propTypes.default.func
};
ProfileDetails.defaultProps = {
  firstName: '',
  lastName: '',
  email: '',
  birthDate: null,
  phoneNumber: null,
  companyName: null,
  isLoading: false,
  capture: null,
  setCurrentUser: () => null,
  updateCaptureOption: () => null,
  t: k => k
};
var _default = exports.default = (0, _reactI18next.withTranslation)()(ProfileDetails);